import { createFileRoute } from '@tanstack/react-router';

import { PortalUpgradePage } from '@/modules/portal/pages/PortalUpgradePage';

export const Route = createFileRoute('/portal/upgrade/')({
  component: PortalUpgradePage,
});
